define('models/Podio.Models.Organization',['require','underscore','lib/backbone/Backbone.PodioModel','lib/Podio.Routes','collections/Podio.Collections.Spaces'],function(require) {

  var _ = require('underscore');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  var routes = require('lib/Podio.Routes');

  var SpacesCollection = require('collections/Podio.Collections.Spaces');

  return PodioModel.extend({

    urlAPI: function() {
      if (_.isDefined(this.get('id'))) {
        return '/org/{0}'.format(this.get('id'));
      } else if (_.isDefined(this.get('org_slug'))) {
        return '/org/url?org_slug={0}'.format(this.get('org_slug'));
      }
    },

    fetchWithItemProperties: function() {
      return this.fetch();
    },

    urlRails: function() {
      return routes.organization_json_path(this.get('url_label'), { format: 'json' });
    },

    has_many : function() {
      return {
        'spaces': SpacesCollection
      };
    },

    isActive: function() {
      return this.get('status') === 'active';
    },

    spacesByTypeAndRank: function() {
      return _.groupBy(this.spacesByRank(), function(space) {
        return space.get('type') === 'emp_network' ? 'emp_network' : 'regular';
      });
    },

    spacesByType: function() {
      return _.groupBy(this.get('spaces').models, function(space) {
        return space.get('type') === 'emp_network' ? 'emp_network' : 'regular';
      });
    },

    spacesByRank: function() {
      return _.sortBy(this.get('spaces').models, function(space) {
        return space.get('rank');
      });
    },

    invitableSpaces: function() {
      var spacesArray = this.get('spaces').filter(function(space) {
        return _.contains(space.get('rights'), 'add_user');
      });

      return new SpacesCollection(spacesArray);
    },

    isEmployee: function() {
      return this.get('role') !== 'light';
    },

    isAdmin: function() {
      return this.get('role') === 'admin';
    },

    upgradeable: function() {
      var hasRegularSpaces = this.get('spaces').some(function(space) {
        return space.get('type') === 'regular';
      });

      var hasAnyEmployeeNetwork = this.get('spaces').some(function(space) {
        return space.get('type') === 'emp_network';
      });

      return this.can('add_contract') && hasRegularSpaces && hasAnyEmployeeNetwork;
    },

    notUpgraded: function() {
      return this.get('contract_status') === 'none';
    },

    partiallyUpgraded: function() {
      return this.get('contract_status') === 'partial';
    }

  });

});

